'use es6';

export default function Auth(state = {}, action) {
  switch (action.type) {
    default:
      return state;
  }
}